import React, { useEffect, useState, useRef } from 'react';
import {
  Header_2026, Footer_2026, DetalleBlog_Header_2026, DetalleBlog_Contenido_2026
  , DetalleBlog_ComentariosResponse_2026, DetalleBlog_Relacionados_2026
} from '../container';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { useAxios } from '../hooks/useAxios';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAxios3 } from "../hooks/useAxios";
import axios from "axios";

const DetallesBlog = () => {
  const { friendly } = useParams();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const idiomaliga = queryParams.get("lang");
  const [t, i18n] = useTranslation("global");
  const [t2] = useTranslation("global");
  const [t3] = useTranslation("detail_blog");
  const [apiUrl, setApiUrl] = useState('');
  const [url2, setUrl2] = useState(`blogs/ranking/` + friendly);
  const { data2, isLoading2, error2 } = useAxios3(url2);
  const [comentariosAll, setComentariosAll] = useState([]);
  const [votos, setVotos] = useState([]);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (idiomaliga) {
      console.log("Idioma: " + idiomaliga);
      setApiUrl(`/blogs/by-friendly/${friendly}?lang=${idiomaliga}`);
    } else {
      setApiUrl(`/blogs/by-friendly-lang/${friendly}`);
    }
  }, [idiomaliga]);

  useEffect(() => {
    if (data2) {
      setVotos(data2);
    }
  }, [data2]);

  useEffect(() => {
    const fetchComentarios = async () => {
      try {
        const response = await axios.get(`https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/comments/byfriendlyresponse/${friendly}?offset=0&limit=1000`);
        setComentariosAll(response.data);
      } catch (error) {
        console.error("Error fetching comentarios: ", error);
      }
    };

    fetchComentarios();
  }, [friendly]);

  const { data, isLoading, error } = useAxios(apiUrl);
  const { titulo, categorias, fecha, lenguaje, resumen, contenidoHtml, blogsRelacionados, comentarios, tag, urlImagen, guid } = !!data && data;

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      console.log("La primera vez");
    } else {
      if (!idiomaliga) {
        setApiUrl(`/blogs/by-friendly/${friendly}?lang=${i18n.language}`);
        console.log("Cambio la liga");
      }
    }
  }, [i18n.language]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      console.log("La primera vez del tag");
    } else {
      if (!idiomaliga) {
        if (tag && tag != 'undefined') {
          navigate(`/blog/${tag}`);
          console.log("Cambio la liga del navegador");
        }
      }
    }
  }, [tag]);

  useEffect(() => {
    if (data && lenguaje && lenguaje !== i18n.language) {
      i18n.changeLanguage(lenguaje);
      console.log(`Idioma del sitio cambiado a ${lenguaje}`);


      const button = document.getElementById("btn_cm_idm");
      if (button) {
        button.click();
        console.log("Botón 'btn_cm_idm' clickeado");
      }
    }
  }, [data, lenguaje, i18n]);

  return (
    <>
      <Header_2026 />
      <div id='top-entrada' class="_nghost-ng-c1842723448">
        <section aria-labelledby="blog-detail-title" class="blog-detail-page">
          <article class="blog-detail-page__article">
            <a
              class="blog-detail-page__back-link blog-detail-page__back-link--top"
              href={"/" + i18n.language + "/Ideas-en-libertad"}>{t3("2026.back")}</a>

            <DetalleBlog_Header_2026 loading={isLoading} titulo={titulo} urlImagen={urlImagen} fecha={fecha} resumen={resumen} ranking={votos.ranking} comentarios={comentariosAll.length} contenidoHtml={contenidoHtml} />
            <DetalleBlog_Contenido_2026 loading={isLoading} categorias={categorias} contenidoHtml={contenidoHtml} />

          </article>
          <DetalleBlog_ComentariosResponse_2026 ranking={votos.ranking} comentarios={comentariosAll} votos={votos.votes} friendlyTag={tag} guid={guid} titulo={titulo} />

          <div class="_ngcontent-ng-c1842723448 _nghost-ng-c2335900281">
            <section aria-label="Suscripción al boletín"
              class="blog-detail-newsletter-cta">
              <div class="blog-detail-newsletter-cta__container">
                <p class="blog-detail-newsletter-cta__message"><span
                  class="blog-detail-newsletter-cta__message-desktop">{(t2('general.suscribirsel'))}</span><span
                    class="blog-detail-newsletter-cta__message-mobile">{(t2('general.suscribirsel2'))}</span></p>
                <button type="button" class="blog-detail-newsletter-cta__button"><span
                  class="blog-detail-newsletter-cta__button-desktop">{(t2('general.suscribirsebtn'))}</span><span
                    class="blog-detail-newsletter-cta__button-mobile">{(t2('general.suscribirsebtn2'))}</span></button>
              </div>
            </section>
          </div>
          <DetalleBlog_Relacionados_2026 blogsRelacionados={blogsRelacionados} categorias={categorias} />
        </section>
      </div>
      <Footer_2026 />
    </>
  );
}

export default DetallesBlog;